


























import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import { PolicyUi, Risk } from '@/common/Policy';
import { PolicyDetails, User } from '@/common/Users';
import Brand from '@/services/Brand';
import Auth from '@/services/Auth';

@Component({
	name: 'PolicySelector',
})
export default class PolicySelector extends Vue {
	private policyNumber: string = '';
	private Brand = Brand.getBrand();
	@Prop() private changePolicyNumber: any;
	@Prop() private labelText?: string;
	@Prop() private usePolicies?: PolicyUi[];

	/**
	 * Identify which policies you want to display to the user.
	 * all - displays all policies on the account
	 * 30Days - display policies that are active and any that have expired in the last 30 days
	 * activePolicies - display only active policies
	 */
	@Prop() private whichPolicies?: 'all' | '30Days' | 'activePolicies';

	@Getter('policiesSortedByDropDownName', { namespace: 'Policy' }) private policies: PolicyUi[];
	@Getter('thirtyDayPolicies', { namespace: 'Policy' }) private ThirtyDays: PolicyUi[];
	@Getter('activePolicies', { namespace: 'Policy' }) private activePolicies: PolicyUi[];
	@Getter('coreUser', { namespace: 'Auth' }) private coreUserRecord: User;

	private updatePolicyNumber(policyNumber) {
		this.policyNumber = policyNumber;
		if (typeof this.changePolicyNumber === 'function') {
			this.changePolicyNumber(policyNumber);
		} else {
			this.$emit('update:changePolicyNumber', policyNumber);
		}
	}

	get getPolicies(): PolicyUi[] {
		let policyList: PolicyUi[];
	
		switch (this.whichPolicies) {
			case 'all':
			default:
				policyList = this.usePolicies ?? this.policies;

			case '30Days':
				policyList = this.ThirtyDays;

			case 'activePolicies':
				policyList = this.activePolicies;
		}

		if ( policyList.length === 1 ) {
			this.policyNumber = policyList[0].policy_number;
			this.updatePolicyNumber( this.policyNumber );
		}

		return policyList;
	}

	get getPolicy(): PolicyUi | undefined {
		return (
			(this.policyNumber &&
				this.getPolicies.find(p => p.policy_number === this.policyNumber)) ||
			undefined
		);
	}

	private getDropDownName(policy: PolicyUi): string {
		try {
			const isAccountAdmin = Auth.checkPermission('ACCOUNT_ADMIN');
			const allUserPolicies = this.coreUserRecord?.policies;
			const userPolicies = allUserPolicies?.[this.Brand];
			if (userPolicies.length < 1 && !isAccountAdmin) {
				return;
			}
			return policy.dropDownPolicyHolderName;
		} catch (e) {
			console.log(e);
			return policy.dropDownPolicyHolderName;
		}
	}
}
